import { authHeader } from './session';
import { getUrl } from './connection';

import { alert } from './stores/alert';
import { loading } from './stores/loading';

import { translate } from './i18n';

import { fetchJson } from './fetchData';

const getColorSchemes = async () => {
    const url = location.host;
    const result = await fetchJson({
        endpoint: 'colorschemes',
        params: {
            url
        }
    });
    return result ? result.data : null;
}

const getComputedVariable = (variable) => {
    return getComputedStyle(document.body).getPropertyValue(variable);
}

const storeColorScheme = async (type, definition) => {
    const url = location.host;
    const result = await fetchJson({
        endpoint: 'savecolorscheme',
        params: {
            url,
            type,
            definition
        }
    });
    return result ? result.data : null;
}

const applyColorScheme = async (type, scheme = null) => {
    try {
        if (!scheme) {
            const schemes = await getColorSchemes();
            if (schemes) {
                scheme = schemes.find(schemeData => schemeData.type === type)?.definition;
            }
        }
    
        if (scheme) {
            const root = document.documentElement;
            for (const [key, value] of Object.entries(scheme)) {
                root.style.setProperty(`--${key}`, value);
            }
        }
    }
    catch (err) {
        console.warn('Error applying color scheme: ', err.message);
    }
}

export { getColorSchemes, getComputedVariable, storeColorScheme, applyColorScheme };
